<div role="group" [attr.aria-labelledby]="'checkbox-label-' + label">
  <div [id]="'checkbox-label-' + label" class="checkbox-label">
    @if (icon) {
      <ion-icon
        [name]="icon"
      />
    }
    <tidy-text
      [body]="label" />
  </div>

  <section>
    @for (item of items; track item) {
      <mat-checkbox (change)="selectItem()" [(ngModel)]="value" class="example-margin" [disabled]="disabled">
        <tidy-text
          [body]="item.viewValue" />
      </mat-checkbox>
    }
  </section>
</div>
